namespace Dashboard {

    class DashboardSeatSelection extends Dashboard.AddOption {

        private selectedSeats;

        constructor(
            protected $location: ng.ILocationService,
            protected $q: ng.IQService,
            protected $routeParams,
            protected $scope: ng.IScope,
            protected $window: ng.IWindowService,
            protected broker: Core.Broker,
            protected customCurrencyFilter,
            protected dashboardBookingService,
            protected flightExtrasService,
            protected mybTrack,
            protected paymentDetailsService,
            protected paymentsService,
            protected paymentsUtilService: Core.PaymentsUtilService,
            protected resourceService: Core.ResourceService,
            protected rootPath: Core.RootPath,
            protected urlUtils,
            protected dateUtil,
            protected currentUser
        ) {
            super($location,
                $q,
                $routeParams,
                $scope,
                $window,
                broker,
                customCurrencyFilter,
                dashboardBookingService,
                flightExtrasService,
                mybTrack,
                paymentDetailsService,
                paymentsService,
                paymentsUtilService,
                resourceService,
                rootPath,
                urlUtils,
                dateUtil,
                currentUser);
        }

        selectSeats (seats, seatsPostAdd) {
            this.selectedSeats = seatsPostAdd;
        }

        getSelectedSeats() {
            return [];
        }

        protected analyticsTrackOpenOption() {
            this.mybTrack.track('MYB - Add Seats Payment', {
                PaymentMethod: this.paymentMethodText[this.paymentTab] || '',
                Source: this.$routeParams.source === 'noneml' ? 'email' : 'cross-Sell',
                SuplierIds: this.supplierIds
            });
        }

        protected getConfig() {
            return {
                completeUrl: 'dashboard/seat-selection/complete/{0}',
                optionsType: 'SeatPlan',
                availableOptionsBinding: 'seatPlan',
                selectedOptionsBinding: 'selectedSeats',
                selectedOptionsRequest: 'SelectedSeats',
                analyticsTag: 'MYB - Open Add Seats',
                pageUrl: 'dashboard/seat-selection'
            };
        }

        protected canAddOption(optionsData) : boolean {
            return !!(optionsData && optionsData.CanAddSeats);
        }
    }


    angular
        .module('dashboard')
        .controller('DashboardSeatSelection', DashboardSeatSelection);

}
